<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
    <div class="bg-white w-fullrounded-lg shadow section-sheet">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
         <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div class="text-xl font-semibold text-blue-500">Import orders</div>
        </div>
      </div>
      <div class="mx-6 md:flex mb-4  p-5  border-2 border-dotted rounded-md border-gray-600">
        <div class="md:w-1/2 px-3">
            <div class="w-full">
                <div class="flex justify-center items-center">
                  <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current mr-2"><path  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"></path></svg>
                  <div class="border-2 hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                          <label for="seller" class="bg-white text-gray-700 px-1">Country (warehouse) <span :class="$colors.required">*</span></label>
                          </p>
                      </div>
                      <p>
                      <v-select @input="setSelectedW" :value="formData.warehouse"  :options="warehouses" label="name">
                          <template slot="option" slot-scope="option">
                              <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                              {{ $f.getCountryNameByCode(options,option.country)}} 
                          </template>
                        </v-select>
                      </p>
                   </div>
                </div>
                <span v-if="checkWarehousingParent.length>0" class="ware_prin">   
                    <div  class="border-2 mll-4 hover:border-blue-400  w-10/12 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerPhone" class="bg-white text-gray-700 px-1">Zone (City)
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <v-select :disabled="formData._id?true:false" @input="setSelectedWParent" v-model="formData.warehouseParent" :options="checkWarehousingParent" label="name"></v-select>
                      </p>
                  </div>
                </span>
               
            </div>
        </div>
          <div v-if="sellers.length > 0 && currentUser.type && currentUser.type !== 'Seller' && formData.warehouse" class="md:w-1/2 px-3 mb-6 md:mb-0">
              <div class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                      <label for="seller" class="bg-white text-gray-700 px-1">Select Seller <span :class="$colors.required">*</span></label>
                      </p>
                  </div>
                  <p>
                    <v-select label="fullName" @search="getUsersDebance($event,'shipsen')" :options="sellers" @input="setSelected"> </v-select>
                  </p>
              </div>
          </div>
          
      </div>
      <div class="px-6" v-if="formData.warehouse">
       <section class="p-5 mb-3 border-2 border-dotted rounded-md border-gray-600">
        <div class="border-2 hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1 mb-2">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="source" class="bg-white text-gray-700 px-1">Prefix ORDER ID</label>
                </p>
              </div>
              <div class="flex flex-wrap">
                
                <input id="source" autocomplete="false" tabindex="0" placeholder="Order id prefix ..." type="text" v-model="prefix.name" class="py-2 text-xs px-2 outline-none block h-full flex-shrink flex-grow flex-auto" />
                <router-link class="flex -mr-px justify-center p-1" to="/settings">
                   <svg class="fill-current cursor-pointer text-blue-700 settingss" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 8.666c-1.838 0-3.333 1.496-3.333 3.334s1.495 3.333 3.333 3.333 3.333-1.495 3.333-3.333-1.495-3.334-3.333-3.334m0 7.667c-2.39 0-4.333-1.943-4.333-4.333s1.943-4.334 4.333-4.334 4.333 1.944 4.333 4.334c0 2.39-1.943 4.333-4.333 4.333m-1.193 6.667h2.386c.379-1.104.668-2.451 2.107-3.05 1.496-.617 2.666.196 3.635.672l1.686-1.688c-.508-1.047-1.266-2.199-.669-3.641.567-1.369 1.739-1.663 3.048-2.099v-2.388c-1.235-.421-2.471-.708-3.047-2.098-.572-1.38.057-2.395.669-3.643l-1.687-1.686c-1.117.547-2.221 1.257-3.642.668-1.374-.571-1.656-1.734-2.1-3.047h-2.386c-.424 1.231-.704 2.468-2.099 3.046-.365.153-.718.226-1.077.226-.843 0-1.539-.392-2.566-.893l-1.687 1.686c.574 1.175 1.251 2.237.669 3.643-.571 1.375-1.734 1.654-3.047 2.098v2.388c1.226.418 2.468.705 3.047 2.098.581 1.403-.075 2.432-.669 3.643l1.687 1.687c1.45-.725 2.355-1.204 3.642-.669 1.378.572 1.655 1.738 2.1 3.047m3.094 1h-3.803c-.681-1.918-.785-2.713-1.773-3.123-1.005-.419-1.731.132-3.466.952l-2.689-2.689c.873-1.837 1.367-2.465.953-3.465-.412-.991-1.192-1.087-3.123-1.773v-3.804c1.906-.678 2.712-.782 3.123-1.773.411-.991-.071-1.613-.953-3.466l2.689-2.688c1.741.828 2.466 1.365 3.465.953.992-.412 1.082-1.185 1.775-3.124h3.802c.682 1.918.788 2.714 1.774 3.123 1.001.416 1.709-.119 3.467-.952l2.687 2.688c-.878 1.847-1.361 2.477-.952 3.465.411.992 1.192 1.087 3.123 1.774v3.805c-1.906.677-2.713.782-3.124 1.773-.403.975.044 1.561.954 3.464l-2.688 2.689c-1.728-.82-2.467-1.37-3.456-.955-.988.41-1.08 1.146-1.785 3.126"/></svg>
                </router-link>
              </div>
        </div>
        <p class="Note"><strong>Note</strong>: Pour utiliser plusieurs numéros, vous pouvez les séparer avec | . <strong>Exemple</strong>: (0708852502<strong>|</strong>0708852501)</p>
        <p class="Note">
          <strong>Note</strong>: Pour ajouter plusieurs produits dans une seule commande, vous pouvez séparer produit id et produit name et quantity et price avec | . 
           <strong>Exemple</strong>: 
          <br>
          <table class="zigzag">
              <thead>
                <tr>
                  <th class="header">ORDER ID</th>
                  <th class="header">PRODUCT ID</th>
                  <th class="header">DATE</th>
                  <th class="header">PRODUCT NAME</th>
                  <th class="header">PRODUCT LINK</th>
                  <th class="header">CONSTUMER NAME</th>
                  <th class="header">PHONE NUMBER</th>
                  <th class="header">ADRESSE</th>
                  <th class="header">PRICE</th>
                  <th class="header">QUANTITY</th>
                  <th class="header">STORE NAME</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{prefix.name?prefix.name+'_1234':'1234'}}</td>
                  <td class="imp">kv6qyr4w<strong class="separe">|</strong>kv6qyc0c</td>
                  <td>15/02/2022</td>
                  <td class="imp">PRODUCT_NAME1<strong class="separe">|</strong>PRODUCT_NAME2</td>
                  <td>LINK</td>
                  <td>Hassan</td>
                  <td>06 xx xx xx xx</td>
                  <td>ADRESSE</td>
                  <td class="imp">900<strong class="separe">|</strong>500</td>
                  <td class="imp">2<strong class="separe">|</strong>1</td>
                  <td>Storeino</td>
                </tr>
              </tbody>
            </table>
            <p class="Note"><strong>Note</strong>: Pour utiliser le <strong>total price</strong> de plusieur products, vous pouvez mettre un seul price a la place de deux prices . <strong>Exemple</strong>: (900<strong class="separe">|</strong>500  ========> <strong class="separe">900</strong>)</p>
        </p>
       </section>
        <div class="relative">
        <div v-if="showprogress" class="k-progressss px-4 mb-10">
              <k-progress 
                  active 
                  status="error" 
                  type="lump"
                  :border="false"
                  :color="['#40a9ff', '#5cdbd3', '#cf1322', '#722ed1']"
                  :percent="parseInt((itemsOrders*100/formData.file.length).toFixed())" >
              </k-progress>
              <div class="flex items-center"><div class="font-mediummm">Importation ...</div><div class="text-xs text-gray-900 ml-auto">{{itemsOrders}} / {{formData.file.length-1}}</div></div>
        </div>
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
        <div class="border-2 border-dashed border-blue-600">
          <input
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="processFile($event)"
            ref="csvOrdersFile"
            type="file"
            class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50"
          />
          <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
            <h4>Drag or click to attach a CSV or Excel file containg your orders</h4>
            <p v-if="this.selectedFileName" class="font-bold">
              Selected file:  
              <span class="text-blue-500"> {{ this.selectedFileName }}</span>
            </p>
          </div>
        </div>
        <div class="p-5 grid justify-items-center">
         
          <button
            @click="uploadOrders"
            icon="publish"
            :disabled="loading"
            class="flex w-32 items-stretch rounded-md mx-1 border border-gray-100 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 focus:outline-none"
          >
            <i class="self-center material-icons">publish</i> Upload
          </button>
        </div>
        </div>
        <div class="intro-y block sm:flex items-center h-200">
           <button
            @click="downloadExample"
            icon="publish"
            class="flex items-stretch btn-upload rounded-md mx-1 border border-gray-100 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 focus:outline-none"
          >
            <i class="self-center material-icons">file_download</i> Download csv example
          </button>
          <div class="flex items-center sm:ml-auto mt-3 sm:mt-0">
              <button v-if="messages.length>0"  @click="openPopup" class="btn boxx flex p-2 items-center bg-green-400 text-white dark:text-gray-300"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> Show messages info </button>
          </div>
        </div>
        <!--p>The csv file should be structered like example below:</p-->
       

        <!--img src="../../assets/csvFileExample.png" /-->
      </div>

      <vue-modal-2  name="messages" :headerOptions="{title: 'Info messages'}" :noFooter="true" modalSize="lg" @on-close="closePopup()">
                <div class="bg-white rounded-lg">
                    <div class="rounded-lg flex">
                      <div class="overflow-x-auto w-full px-4">
                        <table class="table w-full">
                            <thead>
                                <tr class="bg-gray-700 dark:bg-dark-1 text-white text-left"><th class="whitespace-nowrap p-3">Order ID</th><th class="whitespace-nowrap p-3">Message</th><th class="whitespace-nowrap p-3">Status</th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in messages" :key="index"><td class="border-b dark:border-dark-5 p-2">{{ item.orderId }}</td><td class="border-b p-2 dark:border-dark-5"  :class="item.type">{{ item.text }}</td><td class="border-b p-2 dark:border-dark-5" :class="item.type">{{item.type}}</td></tr>
                            </tbody>
                        </table>
                      </div> 
                    </div>
                    <div class="p-4 flex float-right space-x-4">
                        <a href="#" @click="closePopup()" class="px-10 py-2 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                    </div>
                </div>
            </vue-modal-2> 

     
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx"
import * as CSV from 'csv-string';
const iconv = require('iconv-lite');
const mongoose = require('mongoose');
const ObjectID = mongoose.Types.ObjectId;
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {file:[],warehouseParent:null},
      messages: [],
      sellers: [],
      warehouses:[],
      loading:false,
      fullPage: false,
      options:this.$countries,
      selectedFileName: "",
      itemsOrders:0,
      showprogress:false,
      checkWarehousingParent:[],
      prefix:{name:"",country:""}
    };
  },
  async mounted() {
    await this.getCurrentSeller();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    getUsersDebance: _.debounce(async function(name) {
      console.log('name----',name)
      if(this.formData.warehouse){
        await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.formData.warehouse._id||this.formData.warehouse,search:name}).then((res) => {
          this.sellers = res
        })
      }
    }, 500), 
    closePopup(){
      this.$vm2.close('messages');
    },
    openPopup(){
      this.$vm2.open('messages');
    },
    async getWarehouses(){
      this.warehouses = this.currentUser.warehouses;
        // const filter = {limit:1000};
        // const res = await this.$server.search("warehouses",filter);
        // if (res.content.results) {
        //      this.warehouses = res.content.results;
        // } else this.warehouses = [];
    }, 
    setSelected(seller) {
      if (seller) {
        this.formData.seller = seller;
        this.checkPrefix();
      } else {
        this.formData.seller = "";
      }
    },
    async setSelectedW(warhouse){
        this.checkWarehousingParent=[];
        this.formData.warehouseParent=null;
        if (warhouse){
          this.formData.warehouse = warhouse;
          this.checkPrefix();
          const resW = await this.$server.search("warehouses", { country: warhouse.country,all:true,limit:100}); 
          if(resW.content && resW.content.results) {
              this.checkWarehousingParent=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
          }else this.checkWarehousingParent=[];
        } 
        else this.formData.warehouse = null;
    },
    setSelectedWParent(){

    },
    async save() {},
    async processFile(event) {
      if (event.target.files.length) {
         var reader = new FileReader();
          let ExtensionFile=event.target.files[0].name.split('.').pop();
         
        if(ExtensionFile=="csv"){
          //csv file
          this.selectedFileName = event.target.files[0].name;
          //this.formData.file = event.target.files[0];
         
          reader.onload = async (e) => {
            //console.log(e);
             let file = e.target.result.split(",")[1];
             this.formData.type = "Csv";
             const buffer = Buffer.from(file, 'base64');
            //const csvString = buffer.toString('utf-8');
            const csvString =  iconv.decode(buffer, "ISO-8859-1");

            this.formData.file = CSV.parse(csvString);
            this.formData.file=this.formData.file.filter(function(x){return x.length && x[0] && x[1]});

          };
          reader.readAsDataURL(event.target.files[0]);

        }else{
            reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            this.selectedFileName = event.target.files[0].name;
            const wb = XLSX.read(bstr, { type: 'binary', cellDates: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            this.formData.file = data.filter(function(x){return x.length});
            this.formData.type = "Excel";
          }

          reader.readAsBinaryString(event.target.files[0]);
        }
        
      } else {
        this.formData.file = "";
        this.selectedFileName = "";
      }
      this.messages = [];
    },
    async getStatusByName(name) {
        const result = await this.$server.get("status",{  name: name  });
        return result.content._id;
    },
    async uploadOrders() {
      
      if (this.formData.file && this.formData.seller && this.formData.warehouse) {

      // const dataUser = await this.$server.update("users", this.currentUser);

        if(this.checkWarehousingParent.length>0 && this.formData.warehouse && !this.formData.warehouseParent){
            alert("Zone required !", "warning");
            return false;
        }

        let messagesorders = [];
        const nDate = new Date().toLocaleString('en-US', {timeZone: 'Africa/Abidjan'});
       // console.log('formdata------',this.formData.seller)
         if(this.formData.seller.status != 'active'){
              alert("Cette user n'est pas active contacter shipsen pour l'activer merci", "warning");
              return false
          }
        let order = { seller: this.formData.seller,warehouse:this.formData.warehouse._id||this.formData.warehouse,prefix:this.prefix.name||null };
        console.log('order-----------------------',order)
        if(this.checkWarehousingParent && this.checkWarehousingParent.length>0 && this.formData.warehouseParent) order.warehouseParent=this.formData.warehouseParent._id||this.formData.warehouseParent;
        let orderslines=[];
        if (this.formData.file.length==0) { //check if empty!
              alert('Empty file!', "error");
              return false;
        }
        if (this.formData.file.length < 2) { //check length if >= 2! (2 header + at least 1 order)
              alert('File contains only the header!', "error");
              return false;
        }

        const outOfStockStatus = await this.getStatusByName("Waiting");
        const pending = await this.getStatusByName("Pending");

        this.loading=true;
        this.itemsOrders=0;
        this.showprogress = true;
        this.$Progress.start();
        //check file organized
        orderslines=this.formData.file;
       
         orderslines.forEach(function (element, i) {
          console.log('element 11------',element)
          
            const elementrow = element.filter(function (el) {return el?el:'';});
            console.log('element 22------',elementrow)
            if(elementrow.length>11){
                let message = {
                    orderId: element[0],
                    text: `Order not properly organized in line ${i+1}, probably the customer information consists of (,) replace it with (;) and try again`,
                    type: 'error',
                    sort:i+1
                };
                messagesorders.push(message);
                orderslines = orderslines.filter(function( obj ) {return obj[0].toString() !== element[0].toString()}.bind(this));    
            }else element.push(i+1)
        });
        //regroupé row by group same product
         var ress = orderslines.reduce(function(ress, currentValue) {
            if (ress.findIndex(i => (i.id === currentValue[1] || i.name === currentValue[3])) === -1 && currentValue[9] && currentValue[9].toString().toLowerCase() != 'quantity') {
                ress.push({id:currentValue[1],name:currentValue[3]});
            }
            return ress;
        }, []).map(function(group) {
            return {
                product: group,
                datas: orderslines.filter(function(_el) {
                  return _el[1] === group.id || _el[1] === group.name;
               }).map(function(_el) { return {id:order.prefix?`${order.prefix}_${_el[0].toString().trim().replace(/\s+/g, "").replace("-", "_")}`:_el[0].toString().trim().replace(/\s+/g, "").replace("-", "_"),order_id:order.prefix?`${order.prefix}_${_el[0].toString().trim().replace(/\s+/g, "").replace("-", "_")}`:_el[0].toString().trim().replace(/\s+/g, "").replace("-", "_"),product_id:_el[1]?_el[1].toString().trim():'',date:new Date(),product_name:_el[3]?_el[3].toString().trim():'',product_link:_el[4],'customer.fullName':_el[5]?_el[5].toString().trim():null,'customer.phone':_el[6]?_el[6].toString().replace(/[^|\d]/g, ''):null,'customer.address':_el[7]?_el[7].toString():null,'customer.shippingAddress':_el[7]?_el[7].toString():null,price:_el[8],quantity:_el[9]?_el[9]:null,source:_el[10],seller:order.seller,details:[],warehouse:order.warehouse,line:_el[_el.length - 1]} })
            }
        });
       
        //insert data
        console.log('orderslines----------',orderslines)
         console.log('ress order_________',ress)
        
        let productNotDefin=ress.filter(function (el) {return el.product && !el.product.id && !el.product.name;});
         productNotDefin.forEach(function (element) {
            element.datas.forEach(function (order) {
                let message = {
                            orderId: order.order_id,
                            text: `Product in line ${order.line} not defined (product id and product name required !)`,
                            type: 'error',
                            sort:order.line
                        };
                messagesorders.push(message);
            }.bind(this));   
         }.bind(this));

         ress = ress.filter(function (el) {return el.product && el.product.id && el.product.name;});
          console.log('ress 11111 order_________',ress)
         //return false;
        for (let i = 0; i < ress.length; i++) {
          /*--------------Check product if exist--------------------*/
            const productsIds=ress[i].product.id.toString().split('|');
            const productsNames=ress[i].product.name.split('|');
            ress[i].details=[];
            let existProducts=true;let existProductsnames=true;
            console.log('productsIds---------',productsIds.length);
            for (let p = 0; p < productsIds.length; p++) {
                 let resP  = await this.$server.get("products", {ProductBynameAndId:true,warehouse:order.warehouseParent||order.warehouse,id:productsIds[p],seller:this.formData.seller._id||this.formData.seller });
                 
                 ress[i].details.push(resP.content||{name:productsNames[p]||null});
                 
                 if(!productsNames[p]){
                        existProductsnames=false;
                        ress[i].datas.forEach(function (element) {
                          let message = {
                              orderId: element.order_id,
                              text: `Product name obligatoire pour cette id: ${productsIds[p]} in line ${element.line}`,
                              type: 'error',
                              sort: element.line
                          };
                          messagesorders.push(message);
                        });
                 }
            }
          console.log(' ress[i] 00---------', ress[i]);
          ress[i].details.forEach(function (product) {
             if(!product._id){
                 existProducts=false;
                 ress[i].datas.forEach(function (element) {
                    let message = {
                        orderId: element.order_id,
                        text: `Product: ${product.name} (id: ${productsIds}) in line ${element.line} not exist`,
                        type: 'error',
                        sort: element.line
                    };
                    messagesorders.push(message);
                 });
             }else{
                product.productID=product._id;
                product.productPrice=product._id;
                product.inStock=0;
                product.outOfStock=true;
                if(product.details.length>0){
                   product.inStock=product.details[0].quantity.inStock;
                   product.outOfStock=product.details[0].outOfStock;
                }
             }
          }.bind(this)); 
          console.log('dd details----------------',ress[i].details)
         // return false;
           
            // if (!resP.content) {
            //     ress[i].datas.forEach(function (element) {
            //         let message = {
            //             orderId: element.order_id,
            //             text: `Product: ${element.product_name} in line ${element.line} not exist`,
            //             type: 'error',
            //             sort:element.line
            //         };
            //         messagesorders.push(message);
            //      });
            // }
            if(existProducts && existProductsnames){
               
                const UniquedataOrder_id= ress[i].datas.map(e => e['order_id']).map((e, i, final) => final.indexOf(e) === i && i).filter(obj=> ress[i].datas[obj]).map(e => ress[i].datas[e]);
             //   console.log('UniquedataOrder_id11111',UniquedataOrder_id)
                //get duplicated order by ids 
                const duplicateDataOrder = ress[i].datas.map(e => e['order_id']).map((e, i, final) => final.indexOf(e) !== i && i).filter(obj=> ress[i].datas[obj]).map(e => ress[i].datas[e])
                //console.log('duplicateDataOrder',duplicateDataOrder)

                ress[i].datas=UniquedataOrder_id;
               
                duplicateDataOrder.forEach(function (orderD) {
                      let message = {
                          orderId: orderD.order_id,
                          text: `Order id ${orderD.order_id} in line ${orderD.line} duplicated`,
                          type: 'warn',
                          sort:orderD.line
                      };
                      messagesorders.push(message);   
                  }.bind(this));



                  //CHECK DOUBLE ORDER BY PRODUCT && PHONE
                  let duplicates = [];
                  let tempArray = [];

                  ress[i].datas.forEach((element, key) => {
                    let isAlreadyAdded = tempArray.find(
                        (item) => item.product_name && element.product_name && item.product_name === element.product_name && item["customer.phone"] && element["customer.phone"] && item["customer.phone"] === element["customer.phone"]
                    );
                    if (!isAlreadyAdded)  tempArray.push(element); 
                    else duplicates.push(element);
                  });

                  duplicates.forEach(function (orderD) {
                      let message = {
                          orderId: orderD.order_id,
                          text: `Order in line ${orderD.line}, contient produit et telephone existe deja dans un autre commande`,
                          type: 'warn',
                          sort:orderD.line
                      };
                      messagesorders.push(message);   
                     ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== orderD.order_id;}.bind(this)); 
                  }.bind(this));

                  //END / CHECK DOUBLE ORDER BY PRODUCT && PHONE


                /*--------------Check orders ids exists--------------------*/
                // var x = ress[i].datas.map(el => el.order_id);
                //  console.log('x order_________',x)
                // const checkedOrders = await this.$server.bigSearch("orders", {byIds:x ,warehouse:order.warehouse,seller:order.seller._id||order.seller,limit:10000});
                // console.log('check order_________',checkedOrders)
               
                // if (checkedOrders.content.results) {
                //     checkedOrders.content.results.forEach(function (element) {
                //        let filterObj = ress[i].datas.filter(function(e) {return (e.order_id).toString() == this.$f.getIdbySplit(element.id);}.bind(this));
                //       if(filterObj.length>0){
                //        let message = {
                //             orderId: this.$f.getIdbySplit(element.id),
                //             text: `Order in line ${filterObj[0].line} already imported`,
                //             type: 'warn',
                //             sort:filterObj[0].line
                //         };
                //         messagesorders.push(message);
                //       }
                //     ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(element.id);}.bind(this));    
                //    }.bind(this));
                // }


                var x1 = ress[i].datas.map(el => el.order_id);
                let dataOrders=[];
                var itemsCountsOrder=100;
                var countOrder = Math.ceil(x1.length/itemsCountsOrder);
                console.log('x count---------',countOrder)
                var closeOrder=false;
                for (var d = 0; d < countOrder; d++) {
                  if(closeOrder) return;
                  var s1= x1.slice(d*itemsCountsOrder,d*itemsCountsOrder + itemsCountsOrder)
                  console.log('s count---------',s1)
                  const checkedOrders = await this.$server.bigSearch("orders", {byIds:s1,warehouse:order.warehouse,limit:1000});
                  //const checkedOrders = await this.$server.bigSearch("orders", {byIds:s1 ,warehouse:order.warehouse,seller:order.seller._id||order.seller,limit:10000});
                  console.log('x checkedOrders---------',checkedOrders)
                  if(checkedOrders && checkedOrders.content){
                        if(checkedOrders.content.results && checkedOrders.content.results.length>0)  {
                          for (let p in checkedOrders.content.results) {
                             dataOrders.push(checkedOrders.content.results[p])
                          }
                        }
                  }else closeOrder=true;

                  if(closeOrder){alert("Une erreur s'est produite, Le nombre des commandes est peut-être trop élevé. Veuillez résoudre le problème et réessayer.","warning");return false;}
                }

                if (dataOrders && dataOrders.length>0) {
                    // console.log('checkedOrders 11 ids____________',checkedOrders);
                    // console.log('x 11 ids____________',x);
                    dataOrders.forEach(function (element) {
                       let filterObj = ress[i].datas.filter(function(e) {return (e.order_id).toString() == this.$f.getIdbySplit(element);}.bind(this));
                       // console.log('filterObj order_________',filterObj)
                      if(filterObj.length>0){
                       let message = {
                            orderId: this.$f.getIdbySplit(element),
                            text: `Order ID in line ${filterObj[0].line} already exist in the system`,
                            type: 'warn',
                            sort:filterObj[0].line
                        };
                        messagesorders.push(message);
                      }
                    ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(element);}.bind(this));    
                   }.bind(this));  
                }



                 /*--------------check phone number and quantity--------------------*/
                  console.log('data res order_________',ress[i].datas)
                ress[i].datas.forEach(function (element) {
                    if(!element['customer.phone'] || !element['customer.fullName'] || !element['customer.address'] || !element.quantity || !element.price){
                        let feild="Phone number";
                        if(!element['customer.fullName']) feild="Customer fullName";
                        if(!element['customer.address']) feild="Address";
                        if(!element.quantity) feild="Quantity";
                        if(!element.price) feild="Price";
                        let message = {
                            orderId: this.$f.getIdbySplit(element.order_id),
                            text: `${feild} is required in line ${element.line}`,
                            type: 'error',
                            sort:element.line
                        };
                        messagesorders.push(message);
                        ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(element.order_id);}.bind(this)); 
                    }  
                  
                  if(element.quantity && element.price){
                    console.log('quantity--------',element.quantity)
                      const quantityOrders=element.quantity.toString().split('|');
                      quantityOrders.forEach(function (quantity) {
                            if(quantity && !isNaN(quantity) && parseInt(quantity)>20){
                                  let message = {
                                      orderId: this.$f.getIdbySplit(element.order_id),
                                      text: `Check the quantity you entered is too large in line ${element.line}`,
                                      type: 'error',
                                      sort:element.line
                                  };
                                  messagesorders.push(message);
                                  ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(element.order_id);}.bind(this));    
                              }
                              if(quantity && isNaN(quantity)){
                                  let message = {
                                      orderId: this.$f.getIdbySplit(element.order_id),
                                      text: `Check the quantity you entered, it must be a number in line ${element.line}`,
                                      type: 'error',
                                      sort:element.line
                                  };
                                  messagesorders.push(message);
                                  ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(element.order_id);}.bind(this));    
                            }
                      }.bind(this));

                      const pricesOrders=element.price.toString().split('|');
                      pricesOrders.forEach(function (price) {
                            if(price && isNaN(price)){
                                  let message = {
                                      orderId: this.$f.getIdbySplit(element.order_id),
                                      text: `Check the price you entered, it must be a number in line ${element.line}`,
                                      type: 'error',
                                      sort:element.line
                                  };
                                  messagesorders.push(message);
                                  ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(element.order_id);}.bind(this));    
                            }
                      }.bind(this));

                        ress[i].details.forEach(function (product, i) {
                            let productLine = {};

                            //Check sous warehouse
                            if(this.checkWarehousingParent && this.checkWarehousingParent.length>0 && this.formData.warehouseParent){
                               productLine.warehouseParent=this.formData.warehouseParent._id;
                               productLine.warehouseParentName=this.formData.warehouseParent.name;
                            }
                            
                            productLine.product = product.productID; // get product id from product _id !! 
                            if(pricesOrders.length>1) productLine.unitPrice = pricesOrders[i];
                            else productLine.unitPrice = pricesOrders[0];
                            if(quantityOrders.length>1)  productLine.quantity = parseInt(quantityOrders[i]);
                            else productLine.quantity = parseInt(quantityOrders[0]);
                            element.details.push(productLine);
                        }.bind(this));
                      
                      if(ress[i].details.length>1 && pricesOrders.length === 1) {
                          element.totalPrice=pricesOrders[0];
                          element.details.forEach(function (product, i) {
                              product.unitPrice= parseFloat(pricesOrders[0])/element.details.map(item => item.quantity).reduce((prev, curr) => prev + curr, 0);
                          }.bind(this));
                      }  

                      element.status = pending;
                      element.statusCallcenter = pending;

                      for (let index = 0; index < ress[i].details.length; index++) {
                            const orderLine = ress[i].details[index];
                            if (orderLine.outOfStock || parseInt(quantityOrders[index]) > parseInt(orderLine.inStock)) {
                                element.status = outOfStockStatus;
                                element.statusCallcenter = outOfStockStatus;
                                break;
                            }
                      }
                  }
                  

                  //  if (ress[i].outOfStock || parseInt(element.quantity) > parseInt(ress[i].inStock)) {
                  //       element.status = outOfStockStatus;
                  //       element.statusCallcenter = outOfStockStatus;
                  //  }
 
                }.bind(this));
                //  console.log('data res----------',ress[i].datas)
                //  return false;
               
                //check order details
                ress[i].datas.forEach(function (order) {
                  if(order.details && order.details.length>0){
                    order.details.forEach(function (product) {
                      if(!product.product || !product.unitPrice || !product.quantity){
                            let feild="Product";
                            if(!product.product) feild="Product";
                            if(!product.unitPrice) feild="unitPrice";
                            if(!product.quantity) feild="quantity";
                            let message = {
                                    orderId: this.$f.getIdbySplit(order.order_id),
                                    text: `${feild} is required in position ${order.line}`,
                                    type: 'error',
                                    sort:order.line
                                  };
                           
                            messagesorders.push(message);  
                            ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(order.id);}.bind(this));    
                        }
                        if(product.product && !ObjectID.isValid(product.product)){messagespayments.push({orderId:this.$f.getIdbySplit(order.order_id), text: `Product is not valid ObjectID in details in position ${order.line}`,type: 'error',sort:order.line});ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(order.id);}.bind(this));  }
                        if(product.unitPrice && isNaN(product.unitPrice)) {messagespayments.push({orderId:this.$f.getIdbySplit(order.order_id), text: `Check the unitPrice in details, it must be a number in position ${order.line}`,type: 'error',sort:order.line});ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(order.id);}.bind(this));  } 
                        if(product.quantity && isNaN(product.quantity)) {messagespayments.push({orderId:this.$f.getIdbySplit(order.order_id), text: `Check the quantity in details, it must be a number in position ${order.line}`,type: 'error',sort:order.line});ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(order.id);}.bind(this));  } 
                        if(product.quantity && !isNaN(product.quantity) && Number(product.quantity) === product.quantity && product.quantity % 1 !== 0) {messagespayments.push({orderId:this.$f.getIdbySplit(order.order_id), text: `Check the quantity in details, it must be a number not float in position ${order.line}`,type: 'error',sort:order.line});ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(order.id);}.bind(this));  } 
                    }.bind(this));
                  }else{
                    messagespayments.push({orderId:this.$f.getIdbySplit(order.order_id), text: `Items order is not defined in position ${order.line}`,type: 'error',sort:order.line}); 
                    ress[i].datas = ress[i].datas.filter(function( obj ) {return (obj.order_id).toString() !== this.$f.getIdbySplit(order.id);}.bind(this)); 
                  }
                    
                }.bind(this));

                   if(ress[i].datas.length>0){
                     var itemsCounts=100;
                     var count = Math.ceil(ress[i].datas.length/itemsCounts);
                     var close=false;
                     for (var o = 0; o < count; o++) {
                       if(close) return;
                        var s= ress[i].datas.slice(o*itemsCounts,o*itemsCounts + itemsCounts)
                        const insertdatas=await this.$server.insertMany("orders",s);
                        console.log(i,Date.now())
                        if(insertdatas){
                            if(Array.isArray(insertdatas)){
                              this.itemsOrders+=s.length;
                                 s.forEach(function (element) {
                                      let message = {
                                          orderId: element.order_id,
                                          text: 'order created',
                                          type: 'success',
                                          sort:element.line
                                      };
                                      messagesorders.push(message);
                                  }.bind(this));
                            }else{
                                let message = {
                                      orderId: 'The problem ',
                                      text: `Among these orders id, there is a problem {${s.map(el => el.order_id)}} error: ${insertdatas}`,
                                      type: 'error',
                                  };
                                  messagesorders.push(message);
                                  close=true;
                            }
    
                        //await this.reEvaluteOutOfStockOrers({ body: { product: ress[i].productID, orderableQuantity: ress[i].inStock } })
                        }
                        if(close){
                          this.loading=false;
                          this.showprogress = false;
                          this.itemsOrders=0;
                          this.$Progress.finish();
                        }
                      }  
                   }
            }
          }
          //console.log('Exisxt__Product',messages);
          messagesorders.sort(function (a, b) {return a.sort - b.sort;});

       // const messages = await this.$server.import("orders", this.formData);
        this.loading=false;
        this.showprogress = false;
       
        if(messagesorders.length>0){
           this.$Progress.finish();
           this.$vm2.open('messages');
            this.messages = messagesorders;
            alert("Upload result is ready!", "default");
            this.formData.file = "";
            this.selectedFileName = "";
        }else {alert("Une Erreur S'est Produite, Veuillez Réessayer Plus Tard", "error");this.$Progress.fail()}
      } else {
        const isFilePresent = !!this.formData.file;
        const isSellerPresent = !!this.formData.seller;
        const isWarhousePresent = !!this.formData.warehouse;

        let msg = "";
        if (!isFilePresent || !isSellerPresent  || !isWarhousePresent) {
          msg = "please specify ";
          if (!isFilePresent) {
            msg = msg + "the file";
          }
          if (!isFilePresent && !isSellerPresent) {
            msg = msg + " and ";
          }
           if (!isSellerPresent) {
            msg = msg + "the seller";
          }
           if (!isFilePresent && !isWarhousePresent) {
            msg = msg + " and ";
          }
          if (!isWarhousePresent) {
            msg = msg + "the country";
          }
        }

        if (!!msg) {
          alert(msg);
        }
      }

      this.$refs.csvOrdersFile.value = null;
    },
    async getCurrentSeller() {
      if (this.currentUser && this.currentUser.type) {
          this.warehouses = this.currentUser.warehouses;
          if (this.currentUser.type !== "Seller") await this.getSellers();
          else {this.formData.seller = this.currentUser;this.checkPrefix();}
      };
    },
    checkPrefix(){
      console.log('prr-----',this.formData.seller)
      console.log('warehouse-----',this.formData.warehouse)
      if(this.formData.seller && this.formData.seller.prefixs && this.formData.warehouse){
          const checkdata= this.formData.seller.prefixs.find((e) => e.country === this.formData.warehouse.country);
          if(checkdata) this.prefix=checkdata;
          else this.prefix={name:"",country:this.formData.warehouse.country};
      }
    },
    async getSellers() {
      const res = await this.$server.search("users", { type: "Seller",limit:10  });
      if (res && res.content.results) {
        this.sellers = res.content.results;
      }else this.sellers = [];
    },
    async downloadExample(){
        let link = window.document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI("ORDER ID,PRODUCT ID,DATE,PRODUCT NAME,PRODUCT LINK,CONSTUMER NAME,PHONE NUMBER,ADRESSE,PRICE,QUANTITY,STORE"));
        link.setAttribute("download", "orders_example.csv");
        link.click();
    }
  },
};
</script>


<style scoped>
.settingss{
  animation: shadow-pulse 1s infinite;
}
.section-sheet{
  min-height: 500px;
}
.separe{
  padding-left: 1px;
  padding-right: 1px;
}
.imp{
  border: 1px solid;
}
.Note table {
  font-family: sans-serif;
  display: block;
  width: 100%;
  overflow: scroll;
}
.Note table th,.Note table td {
  padding: 0.25em 0.5em;
  text-align: left;
}
.Note table th:nth-child(2), .Note table td:nth-child(2) {
  text-align: left;
}
.Note table td {
  background-color: #eee;
}
.Note table th {
  background-color: #009;
  color: #fff;
}

.zigzag {
  border-collapse: separate;
  border-spacing: 0.25em 1em;
}


#vm2__cover_wrapper_messages{
  z-index:100
}
.boxx {
    border-color: transparent;
    border-radius: .375rem;
    position: relative;
}
.h-200{
  height:6rem
}
.w-32 {
    width: 8rem;
}
.btn-upload {
   background:#0077b5
}
.table-messages{
  display: block;
  max-height: 500px;
  overflow: auto;
}
.error {
  color: #c62525;
}
.success {
  color: #25c631;
}
.warn {
  color: #ff9800;
}
</style>
